import { render, staticRenderFns } from "./NoAccess.component.html?vue&type=template&id=71ddd296&scoped=true&"
import script from "./NoAccess.component.ts?vue&type=script&lang=ts&"
export * from "./NoAccess.component.ts?vue&type=script&lang=ts&"
import style0 from "./NoAccess.component.scss?vue&type=style&index=0&id=71ddd296&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ddd296",
  null
  
)

export default component.exports